<template>
  <div class="class">
    <van-row>
      <van-col span="6">
        <van-sidebar
          v-model="activeKey"
          class="side"
        >
          <van-sidebar-item
            v-for="v in oneclass"
            :key="v.id"
            :title="v.name"
            @click="changeclass(v)"
          />
        </van-sidebar>
      </van-col>
      <van-col
        span="18"
        offset="0"
      >
        <div class="title">
          <van-row>
            <van-col span="8">
              <div class="lhr"></div>
            </van-col>
            <van-col span="8">
              <p>{{name}}</p>
            </van-col>
            <van-col span="8">
              <div class="rhr"></div>
            </van-col>
          </van-row>
        </div>
        <ul>
          <li
            v-for="v in twoclass"
            :key="v.id"
            @click="goproduct(v.id)"
          >
            <div class="img">
              <img
                :src="v.thumb"
                alt=""
              >
            </div>
            <p>{{v.name}}</p>
          </li>

        </ul>
      </van-col>
    </van-row>
    <div
      class="load"
      v-show="load"
    >
      <van-loading />
      <van-loading
        type="spinner"
        color="#1989fa"
      />
    </div>

  </div>
</template>
<script>
import Vue from 'vue';
import { Sidebar, SidebarItem, Col, Row, Loading, Toast } from 'vant';

Vue.use(Sidebar).use(SidebarItem).use(Row).use(Col).use(Loading);
export default {
  created () {
    this.axios.get("categoryList", { params: { store_id: this.$store.state.sonid } }).then(res => {
      this.oneclass = res.data.data.list
      this.name = res.data.data.list[0].name
      this.twoclass = res.data.data.son_list
    }).catch(ref => {
      // console.log(res)
    })
  },
  data () {
    return {
      activeKey: 0,
      oneclass: [],
      twoclass: [],
      name: "",
      load: false,
    }
  },
  methods: {
    changeclass (v) {
      this.load = true
      this.name = v.name
      this.axios.get("categoryList", { params: { store_id: this.$store.state.sonid, class_id: v.id } }).then(res => {
        this.load = false
        this.twoclass = res.data.data.son_list
        document.documentElement.scrollTop = 0
      }).catch(ref => {
        this.load = false
        Toast('请求失败')
        // console.log(res)
      })
    },
    goproduct (id) {
      // if (id.isHasBrand >= 1) {
      //   this.$router.push('brandproduct')
      // } else {
      //   this.$router.push({
      //     name: 'productList',
      //     params: {
      //       id
      //     }
      //   })
      // }
      this.$store.state.pid = id
      this.$router.push({
        name: 'brandproducts',
        query: { id }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.class {
  margin-top: 5%;
  padding-bottom: 1.2rem;
}
.load {
  position: fixed;
  width: 100%;
  height: 90%;
  text-align: center;
  padding-top: 50%;
  background-color: rgba(0, 0, 0, 0.2);
}
.title {
  position: relative;
  .lhr,
  .rhr {
    position: absolute;
    transform: translateY(-50%);
    top: 50%;
    left: 6%;
    width: 2rem;
    height: 0.05rem;
    background-color: #c9c9c9;
  }
  .rhr {
    left: 67%;
  }
  p {
    height: 1rem;
    line-height: 1rem;
    font-size: 0.45rem;
    text-align: center;
  }
}
ul {
  // height: 100%;
  // padding-bottom: 5%;
  li {
    float: left;
    width: 33%;
    .img {
      margin: 0 auto;
      width: 2.133333rem;
      height: 2.133333rem;
      // background-color: #f99;
      img {
        display: block;
        width: 100%;
      }
    }
    p {
      text-align: center;
      height: 1rem;
      line-height: 1rem;
    }
  }
}
</style>